export const INACTIVE_USER_ALERT_KEY = 'inactive-user-alert-shown';
